import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import ErrorBoundary from "./components/ErrorBoundary";
import "iframe-resizer/js/iframeResizer.contentWindow.min.js";
import * as Sentry from "@sentry/browser";

Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN });

const root = ReactDOM.createRoot(document.getElementById("viewer-root"));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
